export interface DspAudienceFee {
    id: number;
    amount: number;
    scale: number;
    currency: string;
    feeCalculationType: string;
    impressionSupplyType: string;
}

export interface DspAudience {
    id?: number;
    platform?: string | null;
    audienceId: string;
    audienceName: string;
    category: string;
    subCategory: string;
    dailyImpressionsLowerBoundInclusive: number | null;
    dailyImpressionsUpperBoundExclusive: number | null;
    dailyReachLowerBoundInclusive: number | null;
    dailyReachUpperBoundExclusive: number | null;
    description: string;
    createDate: Date | null;
    updateDate: Date | null;
    status: string;
    providerId: string;

    fees: DspAudienceFee[];
}

export class DspAudienceSourceCategoryGroup {
    category: string = '';
    audienceSources: DspAudience[] = [];
}
